import Row from '@components/Row';
import styled from '@emotion/styled';

interface Props {
    total: number;
    current: number;
    className?: string;
}

function Indicator({ total, current, className }:Props) {
    return (
        <Row className={className}
            spacing={12}
            aria-label='indicator' >
            {Array.from({ length: total }).map((_, i) => (
                <Dot isActive={i === current}
                    key={`indicator${i}`} />
            ))}
        </Row>
    );
}

const Dot = styled.div<{
    isActive: boolean;
}>`
    background-color: var(--color-gray${({ isActive }) => (isActive ? 6 : 5)});
    border-radius: 4px;
    height: 8px;
    width: 8px;
    transition: background-color 100ms;
`;

export default Indicator;
